import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { selectClientConfig } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { modulesConfig } from '../../config'

const useZohoMcpUnlocker = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isMcpLocked, mcpUnlockError, isMcpClient } = useSelector(selectClientConfig)
  const { isMcpAgent, isAdmin } = useSelector(selectAuthData)
  const blockedForAgent = isMcpLocked && !isMcpAgent
  const { country } = useSelector(selectAuthData)
  const config = modulesConfig[country].zoho ?? {}
  const unlockZohoMcp = () => {
    dispatch({
      type: subscriptionFormActionsV2.ZOHO_MODULE_UNLOCK_MCP_CLIENT_V2,
      genericErrorMsg: t('subscriptionForm:zoho_module.error_unblocking_mcp_zoho'),
    })
  }

  return {
    unlockZohoMcp,
    blockedForAgent,
    mcpUnlockError,
    isAdmin,
    isMcpClient,
    isMcpLocked,
    config,
    t,
  }
}

export default useZohoMcpUnlocker
